const singleVariantProducts = [
    "emma-diamond-pillow",
    "emma-foam-pillow",
    "emma-pillow-bundle",
    "emma-airgrid-pillow"
];

class CrossSellDrawerButton extends HTMLElement {
    constructor() {
        super();
        this.handleOpenCrossSellDrawer = this.handleOpenCrossSellDrawer.bind(this);
    }

    set handleOpenCrossSellDrawerFunction(fn) {
        this._handleOpenCrossSellDrawer = fn;
    }

    connectedCallback() {
        this.addEventListener("click", this.handleOpenCrossSellDrawer);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleOpenCrossSellDrawer);
    }

    handleOpenCrossSellDrawer() {
        if (typeof this._handleOpenCrossSellDrawer === "function") {
            this._handleOpenCrossSellDrawer();
        }
    }
}

customElements.define("cross-sell-drawer-button", CrossSellDrawerButton);

class BlockProductInformation extends HTMLElement {
    constructor() {
        super();
        this.props = {
            type: "",
            title: "",
            image: "",
            handle: "",
            variants: [],
            subtitle: "",
        };
        this.state = {currentVariant: {}};
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render(this.getRenderData());
        if (this.props.type !== "FREEBIE") {
            ProductPageStore.subscribe((event) => {
                const currentVariant = this.getMatchedVariantSize();
                this.updateState({
                    currentVariant: currentVariant
                        ? currentVariant
                        : this.props.variants[0],
                });

            });
        }

        this.attachCallback();
    }

    initProps() {
        this.props = {
            type: this.getAttribute(":type") ?? "",
            actionType: this.getAttribute(":action_type") ?? "drawer",
            title: this.getAttribute(":title"),
            image: this.getAttribute(":image"),
            handle: this.getAttribute(":handle"),
            variants: JSON.parse(this.getAttribute(":variants")),
            subtitle: this.getAttribute(":subtitle"),
        };
    }

    initState() {
        this.state = {
            currentVariant: this.getMatchedVariantSize()
                ? this.getMatchedVariantSize()
                : this.props.variants[0],
        };
    }

    updateState(updates) {
        this.state = {...this.state, ...updates};
        this.render(this.getRenderData());
        this.attachCallback();
    }

    attachCallback() {
        this.querySelectorAll("cross-sell-drawer-button").forEach(
            (button) =>
                (button.handleOpenCrossSellDrawerFunction =
                    this.handleCrossSellDrawerOpen.bind(this))
        );
    }

    getMatchedVariantSize() {
        const currentVariant = ProductPageStore.getState().currentVariant;
        if (!currentVariant) return this.props.variants[0];

        const size = currentVariant.title.split("(")[0].trim();
        const regex = new RegExp(String.raw`^${size}$`, "i");
        return this.props.variants.find((variant) =>
            regex.test(variant.title.split("(")[0].trim())
        );
    }

    handleCrossSellDrawerOpen() {
        if (
            this.props.actionType === "merge_pdp_tabs" &&
            document.querySelector("#joint-product-banners")
        ) {
            document
                .querySelector("#joint-product-banners")
                .scrollIntoView({behavior: "smooth"});
            return;
        }

        window.eventBus.publish("cross-sell-drawer:open", {
            title: this.props.title.replace(" - BambooWeave", ""),
            subtitle: this.props.subtitle,
            drawerDescription: this.shadowRoot.querySelector(
                "cross-sell-drawer-description"
            ).innerHTML,
            image: this.props.image,
            link: "/products/" + this.props.handle,
            primaryButton: {
                text: "제품 보러가기",
                onClick: (state, closeDrawer) => {
                    window.open(state.link, "_blank");
                    closeDrawer();
                },
            },
            secondaryButton: {
                text: "쇼핑 계속하기",
                onClick: (state, closeDrawer) => {
                    closeDrawer();
                },
            },
        });
    }

    getRenderData() {
        const result = {};
        result.title = this.props.title.replace(" - BambooWeave", "");
        result.price = this.state.currentVariant.price / 100;
        result.variantTitle = this.state.currentVariant.option1;
        result.compareAtPrice = this.state.currentVariant.compare_at_price / 100;
        result.image = this.props.image;
        result.isDiscounted =
            this.state.currentVariant.compare_at_price >
            this.state.currentVariant.price;
        result.discountPercentage = result.isDiscounted
            ? Math.round(
                ((this.state.currentVariant.compare_at_price -
                        this.state.currentVariant.price) *
                    100) /
                this.state.currentVariant.compare_at_price
            )
            : 0;
        result.isFreebie = this.props.type === "FREEBIE";
        result.isPillow = singleVariantProducts.includes(this.props.handle);
        return result;
    }

    render(data) {
        this.innerHTML = `
      <div class="flex items-center gap-3">
        <img src="${data.image
        }" width="50" height="50" class="rounded" loading="lazy" alt="">
        <div class="flex-1">
          <cross-sell-drawer-button class="font-semibold text-[14px] block cursor-pointer ">${data.title
        }</cross-sell-drawer-button>
          <div class="grow gap-0 md:gap-1 mt-0 md:mt-1 flex flex-col items-start mg:items-center">
            ${!data.isPillow
            ? `<p class="text-[#55576F] text-sm ${data.variantTitle === "Default Title" ? "hidden" : ""
            }">${data.variantTitle}</p>`
            : ""
        }
            <div class="flex items-center gap-2">
              ${data.isFreebie
            ? `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#FF8900] rounded p-1">FREE</p>
                  <p class="text-sm line-through">${currencyFormatter.format(
                data.price
            )}</p>
                `
            : `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#DA1F00] rounded p-1">${data.discountPercentage
            }% 할인</p>
                  <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""
            }">${currencyFormatter.format(data.price)}</p>
                  ${data.isDiscounted
                ? `<p class="text-sm line-through">${currencyFormatter.format(
                    data.compareAtPrice
                )}</p>`
                : ""
            }
                `
        }
            </div>
          </div>
        </div>
      </div>
  
      <cross-sell-drawer-button class="flex gap-1 items-center underline text-sm font-bold mt-3 cursor-pointer w-max">
        자세히 알아보기
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="#2E2F3C"></path>
        </svg>
      </cross-sell-drawer-button>
    `;
    }
}

customElements.define("block-product-information", BlockProductInformation);

class BlockProductInformationV2 extends HTMLElement {
    constructor() {
        super();
        this.props = {
            type: "",
            title: "",
            image: "",
            handle: "",
            variants: [],
            subtitle: "",
        };
        this.state = {currentVariant: {}};
    }

    connectedCallback() {
        this.initProps();
        this.initState();
        this.render(this.getRenderData());
        if (this.props.type !== "FREEBIE") {
            ProductPageStore.subscribe((event) => {
                const currentVariant = this.getMatchedVariantSize();
                this.updateState({
                    currentVariant: currentVariant
                        ? currentVariant
                        : this.props.variants[0],
                });

            });
        }

        this.attachCallback();
    }

    initProps() {
        this.props = {
            type: this.getAttribute(":type") ?? "",
            actionType: this.getAttribute(":action_type") ?? "drawer",
            title: this.getAttribute(":title"),
            image: this.getAttribute(":image"),
            handle: this.getAttribute(":handle"),
            variants: JSON.parse(this.getAttribute(":variants")),
            subtitle: this.getAttribute(":subtitle"),
        };
    }

    initState() {
        this.state = {
            currentVariant: this.getMatchedVariantSize()
                ? this.getMatchedVariantSize()
                : this.props.variants[0],
        };
    }

    updateState(updates) {
        this.state = {...this.state, ...updates};
        this.render(this.getRenderData());
        this.attachCallback();
    }

    attachCallback() {
        this.querySelectorAll("cross-sell-drawer-button").forEach(
            (button) =>
                (button.handleOpenCrossSellDrawerFunction =
                    this.handleCrossSellDrawerOpen.bind(this))
        );
    }

    getMatchedVariantSize() {
        const currentVariant = ProductPageStore.getState().currentVariant;
        if (!currentVariant) return this.props.variants[0];

        const size = currentVariant.title.split("(")[0].trim();
        const regex = new RegExp(String.raw`^${size}$`, "i");
        return this.props.variants.find((variant) =>
            regex.test(variant.title.split("(")[0].trim())
        );
    }

    handleCrossSellDrawerOpen() {
        if (
            this.props.actionType === "merge_pdp_tabs" &&
            document.querySelector("#joint-product-banners")
        ) {
            document
                .querySelector("#joint-product-banners")
                .scrollIntoView({behavior: "smooth"});
            return;
        }

        window.eventBus.publish("cross-sell-drawer:open", {
            title: this.props.title.replace(" - BambooWeave", ""),
            subtitle: this.props.subtitle,
            drawerDescription: this.shadowRoot.querySelector(
                "cross-sell-drawer-description"
            ).innerHTML,
            image: this.props.image,
            link: "/products/" + this.props.handle,
            primaryButton: {
                text: "제품 보러가기",
                onClick: (state, closeDrawer) => {
                    window.open(state.link, "_blank");
                    closeDrawer();
                },
            },
            secondaryButton: {
                text: "쇼핑 계속하기",
                onClick: (state, closeDrawer) => {
                    closeDrawer();
                },
            },
        });
    }

    getRenderData() {
        const result = {};
        result.title = this.props.title.replace(" - BambooWeave", "");
        result.price = this.state.currentVariant.price / 100;
        result.variantTitle = this.state.currentVariant.option1;
        result.compareAtPrice = this.state.currentVariant.compare_at_price / 100;
        result.image = this.props.image;
        result.isDiscounted =
            this.state.currentVariant.compare_at_price >
            this.state.currentVariant.price;
        result.discountPercentage = result.isDiscounted
            ? Math.round(
                ((this.state.currentVariant.compare_at_price -
                        this.state.currentVariant.price) *
                    100) /
                this.state.currentVariant.compare_at_price
            )
            : 0;
        result.isFreebie = this.props.type === "FREEBIE";
        result.isPillow = singleVariantProducts.includes(this.props.handle);
        return result;
    }

    render(data) {
        this.innerHTML = `
      <div class="flex items-center gap-3">
        <img src="${data.image
        }" width="50" height="50" class="rounded" loading="lazy" alt="">
        <div class="flex-1">
          <cross-sell-drawer-button class="font-semibold text-[14px] block cursor-pointer ">${data.title
        }</cross-sell-drawer-button>
          <div class="grow gap-0 md:gap-1 mt-0 md:mt-1 flex flex-col items-start mg:items-center">
          <p class="text-[#55576F] text-sm">Qty: 1</p>
            <div class="flex items-center gap-2">
              ${data.isFreebie
            ? `
                  <p class="md:flex justify-center items-center text-xs text-white font-bold max-w-max bg-[#FF8900] rounded p-1">FREE</p>
                  <p class="text-sm line-through">${currencyFormatter.format(
                data.price
            )}</p>
                `
            : `
                  <p class="md:flex justify-center items-center text-xs text-black font-bold max-w-max bg-[#FFCD4E] rounded p-1">무료</p>
                  <p class="text-sm ${data.isDiscounted ? "text-[#DA1F00] font-semibold" : ""
            }">${currencyFormatter.format(data.price)}</p>
                  ${data.isDiscounted
                ? `<p class="text-sm line-through">${currencyFormatter.format(
                    data.compareAtPrice
                )}</p>`
                : ""
            }
                `
        }
            </div>
          </div>
        </div>
      </div>
  
      <cross-sell-drawer-button class="flex gap-1 items-center underline text-sm font-bold mt-3 cursor-pointer w-max">
        자세히 알아보기
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.36 7.52661L6.5867 3.75994C6.52472 3.69746 6.45099 3.64786 6.36975 3.61402C6.28851 3.58017 6.20137 3.56274 6.11336 3.56274C6.02535 3.56274 5.93822 3.58017 5.85698 3.61402C5.77574 3.64786 5.702 3.69746 5.64003 3.75994C5.51586 3.88485 5.44617 4.05382 5.44617 4.22994C5.44617 4.40607 5.51586 4.57503 5.64003 4.69994L8.94003 8.03328L5.64003 11.3333C5.51586 11.4582 5.44617 11.6272 5.44617 11.8033C5.44617 11.9794 5.51586 12.1484 5.64003 12.2733C5.70177 12.3363 5.7754 12.3864 5.85665 12.4207C5.9379 12.455 6.02516 12.4729 6.11336 12.4733C6.20157 12.4729 6.28882 12.455 6.37007 12.4207C6.45132 12.3864 6.52495 12.3363 6.5867 12.2733L10.36 8.50661C10.4277 8.44418 10.4817 8.36841 10.5186 8.28408C10.5556 8.19975 10.5747 8.10868 10.5747 8.01661C10.5747 7.92454 10.5556 7.83347 10.5186 7.74914C10.4817 7.66481 10.4277 7.58904 10.36 7.52661Z" fill="#2E2F3C"></path>
        </svg>
      </cross-sell-drawer-button>
    `;
    }
}

customElements.define("block-product-information-v2", BlockProductInformationV2);
